export enum ColumnsEnum {
  REQUEST_DATE = 'request_date',
  PAYMENT_TYPE = 'payment_type',
  AMOUNT = 'amount',
  STATUS = 'status',
  PAYMENT_PERIOD = 'payment_period',
  PAYMENT_TERM = 'payment_term',
}
